module.exports = __webpack_public_path__ + "static/media/check_mark.116134ad.svg";